import { StyledHoverTableRow } from '~/views/Admin/Admin.style';
import {
  ACTION_STATUS,
  // THandleSelectedResources,
} from '~/components/Admin/ResourceTable';
import { HEADER_WIDTH } from '~/views/Admin/Admin.constant';
import { uniqueId } from 'lodash';
import { cell } from '~/components/Admin/ResourceTable/ResourceTable.style';
import { Edit } from '@mui/icons-material';
import { Checkbox, Tooltip } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { TAdminInternetResource } from '~/store/internetResource/internetResource.type';
import { SELECT_ACTION } from '~/types/enum';
import { THandleSelectedResources } from '~/components/Admin/InternetResourceTable';

type TProps = {
  data: TAdminInternetResource;
  isSelected: boolean;
  selectedResourcesLength: number;
  handleSelectedResources: ({
    type,
    resource,
  }: THandleSelectedResources) => void;
  setActionStatus: Dispatch<SetStateAction<ACTION_STATUS>>;
};

export const InternetResourceRow = ({
  data,
  isSelected,
  selectedResourcesLength,
  handleSelectedResources,
  setActionStatus,
}: TProps) => {
  const cellDatas = [
    data.years,
    data.eduCodes,
    data.subjects,
    data.grades,
    data.resources1,
    data.resources2,
    data.urlName,
    data.url,
  ];
  return (
    <StyledHoverTableRow>
      <cell.Container sx={{ ...HEADER_WIDTH(0, 'InternetResource') }}>
        <Checkbox
          sx={{ padding: '0px' }}
          color="info"
          checked={isSelected}
          onChange={(_event, checked) => {
            const currentSelectedResourcesLength = checked
              ? selectedResourcesLength + 1
              : selectedResourcesLength - 1;
            setActionStatus(() => {
              return currentSelectedResourcesLength > 0
                ? ACTION_STATUS.SELECT
                : ACTION_STATUS.NON;
            });
            handleSelectedResources({
              type: checked ? SELECT_ACTION.ADD : SELECT_ACTION.DELETE,
              resource: data,
            });
          }}
        />
      </cell.Container>
      <cell.Container sx={{ ...HEADER_WIDTH(1, 'InternetResource') }}>
        <cell.TypeChip
          key={String(data.category)}
          size="small"
          label={data.category}
          type={data.category}
        />
      </cell.Container>
      {cellDatas.map((list, index) => (
        <cell.Container
          key={uniqueId()}
          sx={{ ...HEADER_WIDTH(index + 2, 'InternetResource') }}
        >
          <Tooltip
            title={[list].join(';')}
            arrow
            placement="top"
            componentsProps={{
              tooltip: {
                sx: {
                  maxWidth: '157px',
                  wordBreak: 'break-all',
                },
              },
            }}
          >
            <cell.EllipsisText fontSize="inherit" fontWeight="inherit">
              {[list].join(';')}
            </cell.EllipsisText>
          </Tooltip>
        </cell.Container>
      ))}

      <cell.Container sx={{ ...HEADER_WIDTH(11, 'InternetResource') }}>
        <cell.EditIconButton
          onClick={() => {
            handleSelectedResources({
              type: SELECT_ACTION.EDIT,
              resource: data,
            });
            setActionStatus(ACTION_STATUS.EDIT);
          }}
        >
          <Edit sx={{ fill: 'info.main' }} />
        </cell.EditIconButton>
      </cell.Container>
    </StyledHoverTableRow>
  );
};
